

import React, { useState, useEffect } from "react";
import './Signup.css';
// import logo1 from '../Images/logo1.jpeg';
import logo1 from '../Images/icon.png';
import lionslogo from '../Images/lionslogo.png';
import lbnlogo from '../Images/lbnlogo.jpeg';
import header from '../Images/header.jpeg';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';
import { Dropdown, FormControl, InputGroup } from 'react-bootstrap';
// import { Country, State } from 'country-state-city';
import { FaUser } from "react-icons/fa";

import { Country, State, City } from 'country-state-city';
import { Modal, Button } from 'react-bootstrap';

const Signup = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeForm, setActiveForm] = useState("member");


  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    membership_number: '',
    mobile: '',
    password: '',
    businessVerticalData: '',
    selectedChapter: "",
    selectedCity: "", 
    selectedState: "",
    no_gst: '',
    referral_id: '',
   
  });
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const slides = [logo1, lionslogo, header, lbnlogo];

  const changeSlide = (direction) => {
    setCurrentSlide((prevSlide) => (prevSlide + direction + slides.length) % slides.length);
  };

  useEffect(() => {
    const slideInterval = setInterval(() => {
      changeSlide(1);
    }, 3000);
    return () => clearInterval(slideInterval);
  }, []);

  const showForm = (formType) => {
    setActiveForm(formType); // Change the active form
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value
    }));
  };

  const navigate = useNavigate()


  const [searchQuery, setSearchQuery] = useState('');
  
  const [searchQuery1, setSearchQuery1] = useState('');
  const [selectedChapter, setSelectedChapter] = useState('');

 const [chapters, setChapters] = useState([]);

    const fetchChapters = async () => {
      const res = await axios.get('https://api.lbnhyderabad.com/admin-dashboard/chapters');
      const chapterNames = res.data.map(item => item.chapter);
      setChapters(chapterNames);
    };
  
    useEffect(() => {
      fetchChapters();
    }, []);


  // const chapters = [
  //   'Chapter-1',
  
   
  // ];


  const [selectedState, setSelectedState] = useState("");
  const [businessVerticalData, setBusinessVerticalData] = useState("");


  const handleChapterSelect = (chapter) => {
    setSelectedChapter(chapter);
    setFormData(prevData => ({
      ...prevData,
      selectedChapter: chapter // Ensure this is added to formData
    }));
  };


  // Handle state selection
  // const handleStateSelect = (state) => {
  //   setSelectedState(state);
  //   setFormData(prevData => ({
  //     ...prevData,
  //     selectedState: state
  //   }));
  // };

  // Handle business vertical selection
  const handleBusinessVerticalSelect = (category) => {
    setBusinessVerticalData(category);
    setFormData(prevData => ({
      ...prevData,
      businessVerticalData: category
    }));
  };


  const filteredChapters = chapters.filter(chapter =>
    chapter.toLowerCase().includes(searchQuery1.toLowerCase())
  );


  const [businessCategories, setBusinessCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [inputCategory, setInputCategory] = useState('');

  useEffect(() => {
    const fetchBusinessCategories = async () => {
      try {
        const response = await axios.get("https://api.lbnhyderabad.com/signup/business-classification"); // Replace with your API URL
        if (response.status === 200) {
          setBusinessCategories(response.data);
          setFilteredCategories(response.data);
        }
      } catch (error) {
        console.error("Error fetching business categories: ", error);
      }
    };

    fetchBusinessCategories();
  }, []);

  const handleCategoryInputChange = (e) => {
    const value = e.target.value;
    setInputCategory(value);
    const filtered = businessCategories.filter(category =>
      category.name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredCategories(filtered);
  };

  const handleCategorySelect = (category) => {
    setInputCategory(category.name);
    setFilteredCategories([]); // Clear filtered categories after selection
  };


  const [states, setStates] = useState([]);

  const [cities, setCities] = useState([]);

  const [selectedCity, setSelectedCity] = useState('');

  const [citySearchQuery, setCitySearchQuery] = useState('');

  // Fetch states of India on initial render
  useEffect(() => {
    // Get India’s ISO code
    const india = Country.getCountryByCode('IN');
    if (india) {
      const stateList = State.getStatesOfCountry(india.isoCode);
      setStates(stateList);
    }
  }, []);


  // Filter states based on the search query
  // const filteredStates = states.filter(state =>
  //   state.name.toLowerCase().includes(searchQuery.toLowerCase())
  // );


  // state and city
  useEffect(() => {
    const india = Country.getCountryByCode('IN');
    if (india) {
      const stateList = State.getStatesOfCountry(india.isoCode);
      setStates(stateList);
    }
  }, []);

  // Handle selecting a state
  // const handleStateSelect = (stateName) => {
  //   setSelectedState(stateName);
  //   setSearchQuery('');
  //   setSelectedCity('');
  //   setCities([]);

  //   const selected = states.find((s) => s.name === stateName);
  //   if (selected) {
  //     // Reliable city fetching using fallback
  //     const cityList = City.getAllCities().filter(
  //       (city) => city.stateCode === selected.isoCode && city.countryCode === 'IN'
  //     );
  //     setCities(cityList);
  //   }
  // };


  const handleStateSelect = (stateName) => {
    setSelectedState(stateName);
    setFormData(prevData => ({
      ...prevData,
      selectedState: stateName
    }));
  
    setSelectedCity('');
    setCities([]);
    setCitySearchQuery('');
  
    const selectedStateObj = states.find((s) => s.name === stateName);
    if (selectedStateObj) {
      const cityList = City.getAllCities().filter(
        (city) =>
          city.stateCode === selectedStateObj.isoCode &&
          city.countryCode === 'IN'
      );
      setCities(cityList);
    }
  };
  

  // Handle selecting a city
  const handleCitySelect = (cityName) => {
    setSelectedCity(cityName);
    setCitySearchQuery('');
  };

  const filteredStates = states.filter(state =>
    state.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredCities = cities.filter(city =>
    city.name.toLowerCase().includes(citySearchQuery.toLowerCase())
  );


  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Form Data being submitted:", formData);
    try {
      // Send POST request with form data
      const response = await axios.post('https://api.lbnhyderabad.com/signup/lbn-signup', formData, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.status === 201) {
        // If signup is successful
        alert('Signup successful! Please login....');
        navigate('/login');
        setFormData({
          full_name: '',
          email: '',
          membership_number: '',
          mobile: '',
          businessVerticalData: '',
          password: '',
          selectedChapter: '',
          
          selectedState: '',
          selectedCity: "", 
          no_gst: '',
          referral_id:'',
        });

        //setFormData({ full_name: '', email: '', membership_number: '', mobile: '', businessVerticalData: "", password: '' }); // Clear form fields
      } else {
        // Handle other success responses if needed
        alert('Something went wrong. Please try again.');
      }
    } catch (err) {
      // Handle different error responses
      if (err.response) {
        // Server responded with an error
        alert(err.response.data.message || 'There was an error with your signup. Please try again.');
      } else {
        // Network or other errors
        alert('Network error. Please check your connection and try again.');
      }
      console.error(err);
    }
  };

  useEffect(() => {
    console.log('Form Data updated:', formData);  // Debugging line to check if formData is updated correctly
  }, [formData]);  // Runs every time formData changes


  const [usersx, setUsersx] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    fetch('https://api.lbnhyderabad.com/signup/api/users')
      .then((response) => response.json())
      .then((data) => setUsersx(data))
      .catch((error) => console.error('Error fetching users:', error));
  }, []);

  const usersOptions = usersx.map((user) => ({
    value: user.id,
    label: user.name,
  }));

  const handleReferralChange = (selectedOption) => {
    const referralId = selectedOption?.value;
    const referralUser = usersx.find((user) => user.id === parseInt(referralId));
    setSelectedReferral(referralUser);
  };


  const [referralSearchQuery, setReferralSearchQuery] = useState('');
const [selectedReferral, setSelectedReferral] = useState(null);

// Filter users based on search
const filteredReferralUsers = usersx.filter((user) =>
  user.name.toLowerCase().includes(referralSearchQuery.toLowerCase())
);

const handleReferralSelect = (user) => {
  setSelectedReferral(user); // for display
  setFormData((prevData) => ({
    ...prevData,
    referral_id: user.id, // 👈 this is what sends to backend
  }));
};


//pop up 
const [showTerms, setShowTerms] = useState(true); // Show on load

  const handleCloseTerms = () => setShowTerms(false);

//   return (
//     <div>
//     <Modal show={showTerms}  size="lg" scrollable backdrop="static" keyboard={false}>
//         <Modal.Header  style={{ backgroundColor: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
//           <Modal.Title style={{ fontWeight: 'bold' }}>Terms of Service</Modal.Title>
//         </Modal.Header>
//         <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px', fontSize: '0.95rem', lineHeight: '1.6' }}>
//           <div>
//             {/* <p><strong style={{ color: '#343a40' }}>Effective Date:</strong> [Insert Date]</p> */}

//             <p>Welcome to <strong>LBN-MD 320 Business Network</strong>, a referral-based business networking platform .
//               These Terms of Service  govern your access to and use of our services, website, and platform . By using our Services, you agree to these Terms.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>1. Eligibility</h5>
//             <p>To use our Services, you must be at least 18 years old and capable of entering into a legally binding agreement.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>2. Account Registration</h5>
//             <p>Users must register for an account to access the full range of Services. You agree to provide accurate and complete information during the registration process. You are responsible for maintaining the confidentiality of your login credentials and for all activities under your account.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>3. Referral Network Participation</h5>
//             <p>You agree to engage in good faith referrals and maintain professional conduct in all interactions. Misuse of the network, spamming, or unethical behavior may result in suspension or termination. You may not use the network to promote illegal or harmful businesses.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>4. Fees & Payments</h5>
//             <p>Membership fees (if applicable) are outlined at the time of registration or renewal. Fees are non-refundable except as required by law or otherwise stated in writing. Failure to pay may result in suspension or loss of access to Services.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>5. Use of Services</h5>
//             <p>You agree to use our Services only for lawful purposes. You may not copy, distribute, or reverse engineer any part of our platform without permission. We reserve the right to remove any content or user we deem inappropriate or in violation of these Terms.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>6. Privacy Policy</h5>
//             <p>Our Privacy Policy describes how we collect, use, and protect your information. By using our Services, you consent to our privacy practices.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>7. Intellectual Property</h5>
//             <p>All content, trademarks, and data on the platform are the property of LBN-MD 320 Business Network or its licensors. You may not use them without express written permission.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>8. Termination</h5>
//             <p>We reserve the right to suspend or terminate your access to the Services at any time, with or without cause or notice.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>9. Disclaimer of Warranties</h5>
//             <p>The Services are provided “as is” and “as available.” We do not warrant that the Services will be uninterrupted, error-free, or meet your expectations.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>10. Limitation of Liability</h5>
//             <p>In no event shall LBN-MD 320 Business Network be liable for any indirect, incidental, special, or consequential damages arising out of your use of the Services.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>11. Indemnification</h5>
//             <p>You agree to indemnify and hold harmless LBN-MD 320 Business Network, its affiliates, and employees from any claims, liabilities, damages, and expenses arising from your use of the Services or violation of these Terms.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>12. Governing Law</h5>
//             <p>These Terms are governed by and construed in accordance with the laws of Telangana, India without regard to its conflict of law principles.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>13. Changes to Terms</h5>
//             <p>We may update these Terms from time to time. Continued use of the Services after changes indicates your acceptance of the revised Terms.</p>

//             <h5 style={{ marginTop: '1.5rem', fontWeight: 'bold' }}>14. Contact Information</h5>
//             <p>If you have any questions or concerns, please contact us at:<br />
//               📧 <a href="mailto:lbnmd320@gmail.com" style={{ color: '#007bff' }}>lbnmd320@gmail.com</a><br />
          
//             </p>

//             <Button variant="primary" onClick={handleCloseTerms} style={{ padding: '8px 20px' }}>
//               I Agree
//             </Button>
//           </div>
//         </Modal.Body>
//         <Modal.Footer style={{ justifyContent: 'center', padding: '15px 30px' }}>
//         </Modal.Footer>
//       </Modal>
//       {/* Main Content */}
//       <div className="main">
//         <div className="card">
//           {/* Left - Carousel */}
//           <div className="left">
//             <div className="carousel">
//               <img alt="Slide 1" className={currentSlide === 0 ? 'active' : ''} src={slides[0]} />
//               <img alt="Slide 2" className={currentSlide === 1 ? 'active' : ''} src={slides[1]} />
//               <img alt="Slide 3" className={currentSlide === 2 ? 'active' : ''} src={slides[2]} />
//               <img alt="Slide 4" className={currentSlide === 3 ? 'active' : ''} src={slides[3]} />
//               <div className="prev" onClick={() => changeSlide(-1)}>&#10094;</div>
//               <div className="next" onClick={() => changeSlide(1)}>&#10095;</div>
//             </div>
//           </div>

//           {/* Right - Forms */}
//           <div className="right">

//             <div className="tabs">
//               <button
//                 className={activeForm === "member" ? "" : "active"}
//                 onClick={() => showForm("member")}
//               >
//                 MEMBER
//               </button>
//             </div>

//             {error && <p className="error-message">{error}</p>}
//             {successMessage && <p className="success-message">{successMessage}</p>}


//             <div id="member-form" className="form-container active" style={{ maxWidth: '100%', margin: '0 auto', padding: '20px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
//               <form onSubmit={handleSubmit}>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', flexWrap: 'wrap' }}>
//                   <div className="form-group" style={{ flex: '1', minWidth: '200px', marginBottom: '10px' }}>
//                     <label htmlFor="full-name" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Full Name *</label>
//                     <input
//                       type="text"
//                       id="full_name"
//                       value={formData.full_name}
//                       onChange={handleInputChange}
//                       placeholder="Enter your full name"
//                       required
//                       style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '16px' }}
//                     />
//                   </div>
//                   <div className="form-group" style={{ flex: '1', minWidth: '200px', marginBottom: '10px' }}>
//                     <label htmlFor="email" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Email *</label>
//                     <input
//                       type="email"
//                       id="email"
//                       value={formData.email}
//                       onChange={handleInputChange}
//                       placeholder="Enter your email"
//                       required
//                       style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '16px' }}
//                     />
//                   </div>
//                 </div>

//                 <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', flexWrap: 'wrap' }}>
//                   <div className="form-group" style={{ flex: '1', minWidth: '200px', marginBottom: '10px' }}>
//                     <label htmlFor="membership-number" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Membership Number *</label>
//                     <input
//                       type="text"
//                       id="membership_number"
//                       value={formData.membership_number}
//                       onChange={handleInputChange}
//                       placeholder="Enter your membership No"
//                       required
//                       style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '16px' }}
//                     />
//                   </div>
//                   <div className="form-group" style={{ flex: '1', minWidth: '200px', marginBottom: '10px' }}>
//                     <label htmlFor="mobile" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Mobile *</label>
//                     <input
//                       type="text"
//                       id="mobile"
//                       value={formData.mobile}
//                       onChange={handleInputChange}
//                       placeholder="Enter your mobile"
//                       required
//                       style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '16px' }}
//                     />
//                   </div>
//                 </div>


//                 <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', flexWrap: 'wrap' }}>

//                 <div className="form-group" style={{ marginBottom: '10px' }}>
//                     <label htmlFor="business-category" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
//                       Business Category
//                     </label>

//                     <Dropdown>
//                       <Dropdown.Toggle id="dropdown-business-category" style={{ backgroundColor: 'lightblue', color: 'black', width: '100%' }}>
//                         {businessVerticalData || 'Select Business Category'}
//                       </Dropdown.Toggle>

//                       <Dropdown.Menu
//                         style={{
//                           maxHeight: '200px',
//                           overflowY: 'auto',
//                           width: '100%',
//                           padding: '0',
//                           marginTop: '5px',
//                         }}
//                       >
//                         {/* Search Input */}
//                         <InputGroup className="mb-3">
//                           <FormControl
//                             placeholder="Search categories..."
//                             aria-label="Search Categories"
//                             value={inputCategory}
//                             onChange={handleCategoryInputChange}
//                           />
//                         </InputGroup>

//                         {/* Display filtered categories */}
//                         {filteredCategories.length > 0 && (
//                           filteredCategories.map((category) => (
//                             <Dropdown.Item
//                               key={category.sno}
//                               // onClick={() => handleCategorySelect(category)}
//                               //  onClick={() => {
//                               //   setBusinessVerticalData(category.name);
//                               //   setInputCategory(''); // Clear search when a category is selected
//                               // }} 
//                               onClick={() => handleBusinessVerticalSelect(category.name)}
//                               style={{
//                                 padding: '10px',
//                                 cursor: 'pointer',
//                                 backgroundColor: 'white',
//                                 color: 'black',
//                                 transition: 'background-color 0.3s',
//                               }}
//                               onMouseEnter={(e) => {
//                                 e.target.style.backgroundColor = '#f0f0f0';
//                               }}
//                               onMouseLeave={(e) => {
//                                 e.target.style.backgroundColor = 'white';
//                               }}
//                             >
//                               {category.name}
//                             </Dropdown.Item>
//                           ))
//                         )}
//                         {/* If no categories match the search, show a message */}
//                         {filteredCategories.length === 0 && inputCategory && (
//                           <Dropdown.Item disabled>No categories found</Dropdown.Item>
//                         )}
//                       </Dropdown.Menu>
//                     </Dropdown>
//                   </div>

            
//                     </div>

//                 <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', flexWrap: 'wrap' }}>

                

//                   {/* <div className="form-group" style={{ marginBottom: '10px' }}>
//                     <label htmlFor="state" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
//                       State *
//                     </label>

//                     <Dropdown>
//                       <Dropdown.Toggle
//                         id="dropdown-state"
//                         style={{ backgroundColor: 'lightblue', color: 'black', width: '100%' }}
//                       >
//                         {selectedState || 'Select your State'}
//                       </Dropdown.Toggle>

//                       <Dropdown.Menu
//                         style={{
//                           maxHeight: '200px',
//                           overflowY: 'auto',
//                           width: '100%',
//                           padding: '0',
//                           marginTop: '5px',
//                         }}
//                       >
//                         <InputGroup className="mb-3">
//                           <FormControl
//                             placeholder="Search..."
//                             aria-label="Search States"
//                             value={searchQuery}
//                             onChange={e => setSearchQuery(e.target.value)}
//                           />
//                         </InputGroup>

//                         {filteredStates.map((state) => (
//                           <Dropdown.Item
//                             key={state.isoCode}
//                             // onClick={() => {
//                             //   setSelectedState(state.name);
//                             //   setSearchQuery(''); // Reset search query when selecting an item
//                             // }}
//                             onClick={() => handleStateSelect(state.name)}
//                           >
//                             {state.name}
//                           </Dropdown.Item>
//                         ))}
//                       </Dropdown.Menu>
//                     </Dropdown>
//                   </div> */}

// <div className="form-group" style={{ marginBottom: '10px' }}>
//         <label htmlFor="state" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
//           State *
//         </label>

//         <Dropdown>
//           <Dropdown.Toggle
//             id="dropdown-state"
//             style={{ backgroundColor: 'lightblue', color: 'black', width: '100%' }}
//           >
//             {selectedState || 'Select your State'}
//           </Dropdown.Toggle>

//           <Dropdown.Menu
//             style={{
//               maxHeight: '200px',
//               overflowY: 'auto',
//               width: '100%',
//               padding: '0',
//               marginTop: '5px',
//             }}
//           >
//             <InputGroup className="mb-3">
//               <FormControl
//                 placeholder="Search..."
//                 aria-label="Search States"
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//               />
//             </InputGroup>

//             {filteredStates.map((state) => (
//               <Dropdown.Item key={state.isoCode} onClick={() => handleStateSelect(state.name)}>
//                 {state.name}
//               </Dropdown.Item>
//             ))}
//           </Dropdown.Menu>
//         </Dropdown>
//       </div>

//       <div className="form-group" style={{ marginBottom: '10px' }}>
//         <label htmlFor="city" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
//           City *
//         </label>

//         <Dropdown>
//   <Dropdown.Toggle
//     id="dropdown-city"
//     style={{ backgroundColor: 'lightblue', color: 'black', width: '100%' }}
//   >
//     {selectedCity || 'Select your City'}
//   </Dropdown.Toggle>

//   <Dropdown.Menu
//     style={{
//       maxHeight: '200px',
//       overflowY: 'auto',
//       width: '100%',
//       padding: '0',
//       marginTop: '5px',
//     }}
//   >
//     <InputGroup className="mb-3">
//       <FormControl
//         placeholder="Search..."
//         aria-label="Search Cities"
//         value={citySearchQuery}
//         onChange={(e) => setCitySearchQuery(e.target.value)}
//       />
//     </InputGroup>

//     {cities
//       .filter(city =>
//         city.name.toLowerCase().includes(citySearchQuery.toLowerCase())
//       )
//       .map(city => (
//         <Dropdown.Item
//           key={city.name}
//           onClick={() => {
//             setSelectedCity(city.name);
//             setFormData(prev => ({
//               ...prev,
//               selectedCity: city.name
//             }));
//           }}
//         >
//           {city.name}
//         </Dropdown.Item>
//       ))}
//   </Dropdown.Menu>
// </Dropdown>

//       </div>

//                 </div>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', flexWrap: 'wrap' }}>

                
//                 <div className="form-group" style={{ marginBottom: '10px' }}>
//                   <label htmlFor="chapter" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
//                         Chapter
//                       </label>

//                       <Dropdown>
//                         <Dropdown.Toggle id="dropdown-chapters" style={{ backgroundColor: 'lightblue', color: 'black', width: '100%' }}>
//                           {selectedChapter || 'Select your Chapter'}
//                         </Dropdown.Toggle>

//                         <Dropdown.Menu
//                           style={{
//                             maxHeight: '200px',
//                             overflowY: 'auto',
//                             width: '100%',
//                             padding: '0',
//                             marginTop: '5px',
//                           }}
//                         >
//                           <InputGroup className="mb-3">
//                             <FormControl
//                               placeholder="Search..."
//                               aria-label="Search Chapters"
//                               value={searchQuery1}
//                               onChange={e => setSearchQuery1(e.target.value)}
//                             />
//                           </InputGroup>

//                           {filteredChapters.map((chapter, index) => (
//                             <Dropdown.Item
//                               key={index}
//                               // onClick={() => {
//                               //   setSelectedChapter(chapter);
//                               //   setSearchQuery(''); // Reset search query when selecting an item
//                               // }}
//                               onClick={() => handleChapterSelect(chapter)}
//                             >
//                               {chapter}
//                             </Dropdown.Item>
//                           ))}
//                         </Dropdown.Menu>
//                       </Dropdown>
//                     </div> 


//                     <div className="form-group" style={{ marginBottom: '10px' }}>
//                   <label htmlFor="referral" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
//                     <FaUser className="me-2" />Referred Members
//                   </label>

//                   <Dropdown>
//                     <Dropdown.Toggle
//                       id="dropdown-referral"
//                       style={{ backgroundColor: 'lightblue', color: 'black', width: '100%' }}
//                     >
//                       {selectedReferral?.name || 'Select Referral Member'}
//                     </Dropdown.Toggle>

//                     <Dropdown.Menu
//                       style={{
//                         maxHeight: '200px',
//                         overflowY: 'auto',
//                         width: '100%',
//                         padding: '0',
//                         marginTop: '5px',
//                       }}
//                     >
//                       <InputGroup className="mb-3">
//                         <FormControl
//                           placeholder="Search..."
//                           aria-label="Search Users"
//                           value={referralSearchQuery}
//                           onChange={(e) => setReferralSearchQuery(e.target.value)}
//                         />
//                       </InputGroup>

//                       {filteredReferralUsers.map((user) => (
//                         <Dropdown.Item
//                           key={user.id}
//                           // onClick={() => {
//                           //   setSelectedReferral(user);
//                           //   setReferralSearchQuery('');
//                           // }}
//                           onClick={() => handleReferralSelect(user)}
//                         >
//                           {user.name}
//                         </Dropdown.Item>
//                       ))}
//                     </Dropdown.Menu>
//                   </Dropdown>
//                 </div>
// </div>
//                 <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
//                   <label htmlFor="state" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
//                     "If you don't have a GST number, please check this box."*
//                   </label>
//                   <input
//                     type="checkbox"
//                     id="no_gst"
//                     checked={formData.no_gst || false}
//                     onChange={(e) =>
//                       setFormData(prevData => ({
//                         ...prevData,
//                         no_gst: e.target.checked
//                       }))
//                     }
//                     style={{ width: '20px', height: '20px' }}
//                   />
//                   <label htmlFor="no_gst" style={{ fontWeight: 'bold', margin: 0 }}>No GST *</label>
//                 </div>

              

//                 <div className="form-group" style={{ marginBottom: '10px' }}>
//                   <label htmlFor="password" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Password *</label>
//                   <input
//                     type="password"
//                     id="password"
//                     value={formData.password}
//                     onChange={handleInputChange}
//                     placeholder="Enter your password"
//                     required
//                     style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', fontSize: '16px' }}
//                   />
//                 </div>

              

//                 <button type="submit" className="signup-btn" style={{ backgroundColor: '#4CAF50', padding: '10px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '16px', color: 'white' }}>
//                   SIGNUP
//                 </button>
//               </form>
//             </div>


//             <div className="login-link">
//               <p>
//                 You already have an account? <a href="/login">Login Now</a>
//               </p>
//               {/* <p className="form-group" style={{ marginBottom: '10px' }}>
//                   <a href="/forgotpassword">Forgot password?</a>
//                 </p> */}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

return (
  <div
    style={{
      minHeight: "100vh",
      background: "linear-gradient(to bottom right, #f9fafb, #dbeafe)",
      padding: "40px 15px",
    }}
  >
    <Modal
      show={showTerms}
      size="lg"
      scrollable
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header
        style={{
          background:
            "linear-gradient(to right, #1e3a8a, #1e40af)",
          color: "white",
          borderBottom: "none",
        }}
      >
        <Modal.Title style={{ fontWeight: "700" }}>
          Terms of Service
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          maxHeight: "70vh",
          overflowY: "auto",
          padding: "25px",
          lineHeight: "1.8",
          fontSize: "15px",
        }}
      >
        <div>
          <p>
            Welcome to <strong>LBN-MD 320 Business Network</strong>,
            a referral-based business networking platform.
          </p>

          <h5 style={{ marginTop: "20px", fontWeight: "700" }}>
            1. Eligibility
          </h5>
          <p>
            To use our Services, you must be at least 18 years old.
          </p>

          <h5 style={{ marginTop: "20px", fontWeight: "700" }}>
            2. Account Registration
          </h5>
          <p>
            Users must register for an account to access the
            Services.
          </p>

          <h5 style={{ marginTop: "20px", fontWeight: "700" }}>
            3. Referral Network Participation
          </h5>
          <p>
            You agree to engage in good faith referrals and
            maintain professional conduct.
          </p>

          <h5 style={{ marginTop: "20px", fontWeight: "700" }}>
            4. Fees & Payments
          </h5>
          <p>
            Membership fees are outlined during registration.
          </p>

          <h5 style={{ marginTop: "20px", fontWeight: "700" }}>
            5. Use of Services
          </h5>
          <p>
            You agree to use our Services only for lawful
            purposes.
          </p>

          <h5 style={{ marginTop: "20px", fontWeight: "700" }}>
            6. Privacy Policy
          </h5>
          <p>
            Our Privacy Policy describes how we collect and
            protect your information.
          </p>

          <h5 style={{ marginTop: "20px", fontWeight: "700" }}>
            7. Intellectual Property
          </h5>
          <p>
            All content and trademarks are property of
            LBN-MD 320 Business Network.
          </p>

          <h5 style={{ marginTop: "20px", fontWeight: "700" }}>
            8. Termination
          </h5>
          <p>
            We reserve the right to suspend or terminate access.
          </p>

          <h5 style={{ marginTop: "20px", fontWeight: "700" }}>
            9. Contact Information
          </h5>

          <p>
            📧{" "}
            <a
              href="mailto:lbnmd320@gmail.com"
              style={{
                color: "#1e3a8a",
                textDecoration: "none",
                fontWeight: "600",
              }}
            >
              lbnmd320@gmail.com
            </a>
          </p>

          <Button
            variant="primary"
            onClick={handleCloseTerms}
            style={{
              marginTop: "20px",
              padding: "10px 25px",
              borderRadius: "10px",
              background:
                "linear-gradient(to right, #1e3a8a, #1e40af)",
              border: "none",
            }}
          >
            I Agree
          </Button>
        </div>
      </Modal.Body>
    </Modal>

    <div
      style={{
        width: "100%",
        maxWidth: "1400px",
        margin: "0 auto",
        display: "grid",
        gridTemplateColumns:
          window.innerWidth > 992 ? "1fr 1.2fr" : "1fr",
        background: "#fff",
        borderRadius: "24px",
        overflow: "hidden",
        boxShadow: "0 20px 50px rgba(0,0,0,0.15)",
      }}
    >
      {/* LEFT SIDE */}
      <div
        style={{
          position: "relative",
          display: window.innerWidth > 992 ? "block" : "none",
          minHeight: "100%",
        }}
      >
        <div className="carousel" style={{ height: "100%" }}>
          <img
            alt="Slide 1"
            className={currentSlide === 0 ? "active" : ""}
            src={slides[0]}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              position: "absolute",
            }}
          />

          <img
            alt="Slide 2"
            className={currentSlide === 1 ? "active" : ""}
            src={slides[1]}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              position: "absolute",
            }}
          />

          <img
            alt="Slide 3"
            className={currentSlide === 2 ? "active" : ""}
            src={slides[2]}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              position: "absolute",
            }}
          />

          <img
            alt="Slide 4"
            className={currentSlide === 3 ? "active" : ""}
            src={slides[3]}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              position: "absolute",
            }}
          />

          {/* OVERLAY */}
          {/* <div
            style={{
              position: "absolute",
              inset: 0,
              // background:
              //   "linear-gradient(to bottom right, rgba(30,58,138,0.92), rgba(30,64,175,0.92))",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "40px",
              zIndex: 2,
            }}
          >
            <div
              style={{
                textAlign: "center",
                color: "#fff",
              }}
            >
              <div
                style={{
                  width: "90px",
                  height: "90px",
                  borderRadius: "50%",
                  background:
                    "linear-gradient(to bottom right, #fbbf24, #f59e0b)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 25px",
                  fontSize: "30px",
                  fontWeight: "bold",
                  color: "#1e3a8a",
                }}
              >
                LBN
              </div>

              <h2
                style={{
                  fontSize: "36px",
                  fontWeight: "700",
                  marginBottom: "10px",
                }}
              >
                Lions Business Network
              </h2>

              <p
                style={{
                  fontSize: "18px",
                  opacity: 0.9,
                }}
              >
                Multiple District 320
              </p>
            </div>
          </div> */}
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div
        style={{
          padding: window.innerWidth > 768 ? "50px" : "25px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: "35px",
          }}
        >
          <div
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background:
                "linear-gradient(to bottom right, #fbbf24, #f59e0b)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 20px",
              fontSize: "28px",
              fontWeight: "700",
              color: "#1e3a8a",
            }}
          >
            LBN
          </div>

          <h1
            style={{
              fontSize: "34px",
              fontWeight: "700",
              color: "#1f2937",
              marginBottom: "10px",
            }}
          >
            Create Your Account
          </h1>

          <p
            style={{
              color: "#6b7280",
              fontSize: "15px",
            }}
          >
            Join Lions Business Network – Multiple District 320
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* ROW 1 */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                window.innerWidth > 768 ? "1fr 1fr" : "1fr",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Full Name *
              </label>

              <input
                type="text"
                id="full_name"
                value={formData.full_name}
                onChange={handleInputChange}
                placeholder="Enter your full name"
                required
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  border: "1px solid #d1d5db",
                  borderRadius: "12px",
                  fontSize: "15px",
                  outline: "none",
                }}
              />
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Email *
              </label>

              <input
                type="email"
                id="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your email"
                required
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  border: "1px solid #d1d5db",
                  borderRadius: "12px",
                  fontSize: "15px",
                  outline: "none",
                }}
              />
            </div>
          </div>

          {/* ROW 2 */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                window.innerWidth > 768 ? "1fr 1fr" : "1fr",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Membership Number *
              </label>

              <input
                type="text"
                id="membership_number"
                value={formData.membership_number}
                onChange={handleInputChange}
                placeholder="Enter your membership No"
                required
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  border: "1px solid #d1d5db",
                  borderRadius: "12px",
                  fontSize: "15px",
                  outline: "none",
                }}
              />
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Mobile *
              </label>

              <input
                type="text"
                id="mobile"
                value={formData.mobile}
                onChange={handleInputChange}
                placeholder="Enter your mobile"
                required
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  border: "1px solid #d1d5db",
                  borderRadius: "12px",
                  fontSize: "15px",
                  outline: "none",
                }}
              />
            </div>
          </div>

          {/* BUSINESS CATEGORY */}
          <div style={{ marginBottom: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#374151",
              }}
            >
              Business Category
            </label>

            <Dropdown>
              <Dropdown.Toggle
                id="dropdown-business-category"
                style={{
                  width: "100%",
                  padding: "14px 16px",
                  background: "#fff",
                  color: "#111827",
                  border: "1px solid #d1d5db",
                  borderRadius: "12px",
                  textAlign: "left",
                }}
              >
                {businessVerticalData || "Select Business Category"}
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{
                  width: "100%",
                  maxHeight: "250px",
                  overflowY: "auto",
                }}
              >
                <InputGroup className="mb-2 px-2 pt-2">
                  <FormControl
                    placeholder="Search categories..."
                    value={inputCategory}
                    onChange={handleCategoryInputChange}
                  />
                </InputGroup>

                {filteredCategories.map((category) => (
                  <Dropdown.Item
                    key={category.sno}
                    onClick={() =>
                      handleBusinessVerticalSelect(category.name)
                    }
                  >
                    {category.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {/* STATE CITY */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                window.innerWidth > 768 ? "1fr 1fr" : "1fr",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                State *
              </label>

              <Dropdown>
                <Dropdown.Toggle
                  id="dropdown-state"
                  style={{
                    width: "100%",
                    padding: "14px 16px",
                    background: "#fff",
                    color: "#111827",
                    border: "1px solid #d1d5db",
                    borderRadius: "12px",
                    textAlign: "left",
                  }}
                >
                  {selectedState || "Select your State"}
                </Dropdown.Toggle>

                <Dropdown.Menu
                  style={{
                    width: "100%",
                    maxHeight: "250px",
                    overflowY: "auto",
                  }}
                >
                  <InputGroup className="mb-2 px-2 pt-2">
                    <FormControl
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) =>
                        setSearchQuery(e.target.value)
                      }
                    />
                  </InputGroup>

                  {filteredStates.map((state) => (
                    <Dropdown.Item
                      key={state.isoCode}
                      onClick={() =>
                        handleStateSelect(state.name)
                      }
                    >
                      {state.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                City *
              </label>

              <Dropdown>
                <Dropdown.Toggle
                  id="dropdown-city"
                  style={{
                    width: "100%",
                    padding: "14px 16px",
                    background: "#fff",
                    color: "#111827",
                    border: "1px solid #d1d5db",
                    borderRadius: "12px",
                    textAlign: "left",
                  }}
                >
                  {selectedCity || "Select your City"}
                </Dropdown.Toggle>

                <Dropdown.Menu
                  style={{
                    width: "100%",
                    maxHeight: "250px",
                    overflowY: "auto",
                  }}
                >
                  <InputGroup className="mb-2 px-2 pt-2">
                    <FormControl
                      placeholder="Search..."
                      value={citySearchQuery}
                      onChange={(e) =>
                        setCitySearchQuery(e.target.value)
                      }
                    />
                  </InputGroup>

                  {cities
                    .filter((city) =>
                      city.name
                        .toLowerCase()
                        .includes(
                          citySearchQuery.toLowerCase()
                        )
                    )
                    .map((city) => (
                      <Dropdown.Item
                        key={city.name}
                        onClick={() => {
                          setSelectedCity(city.name);
                          setFormData((prev) => ({
                            ...prev,
                            selectedCity: city.name,
                          }));
                        }}
                      >
                        {city.name}
                      </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          {/* CHAPTER REFERRAL */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                window.innerWidth > 768 ? "1fr 1fr" : "1fr",
              gap: "20px",
              marginBottom: "20px",
            }}
          >
            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Chapter
              </label>

              <Dropdown>
                <Dropdown.Toggle
                  id="dropdown-chapters"
                  style={{
                    width: "100%",
                    padding: "14px 16px",
                    background: "#fff",
                    color: "#111827",
                    border: "1px solid #d1d5db",
                    borderRadius: "12px",
                    textAlign: "left",
                  }}
                >
                  {selectedChapter || "Select your Chapter"}
                </Dropdown.Toggle>

                <Dropdown.Menu
                  style={{
                    width: "100%",
                    maxHeight: "250px",
                    overflowY: "auto",
                  }}
                >
                  <InputGroup className="mb-2 px-2 pt-2">
                    <FormControl
                      placeholder="Search..."
                      value={searchQuery1}
                      onChange={(e) =>
                        setSearchQuery1(e.target.value)
                      }
                    />
                  </InputGroup>

                  {filteredChapters.map((chapter, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={() =>
                        handleChapterSelect(chapter)
                      }
                    >
                      {chapter}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#374151",
                }}
              >
                Referred Members
              </label>

              <Dropdown>
                <Dropdown.Toggle
                  id="dropdown-referral"
                  style={{
                    width: "100%",
                    padding: "14px 16px",
                    background: "#fff",
                    color: "#111827",
                    border: "1px solid #d1d5db",
                    borderRadius: "12px",
                    textAlign: "left",
                  }}
                >
                  {selectedReferral?.name ||
                    "Select Referral Member"}
                </Dropdown.Toggle>

                <Dropdown.Menu
                  style={{
                    width: "100%",
                    maxHeight: "250px",
                    overflowY: "auto",
                  }}
                >
                  <InputGroup className="mb-2 px-2 pt-2">
                    <FormControl
                      placeholder="Search..."
                      value={referralSearchQuery}
                      onChange={(e) =>
                        setReferralSearchQuery(
                          e.target.value
                        )
                      }
                    />
                  </InputGroup>

                  {filteredReferralUsers.map((user) => (
                    <Dropdown.Item
                      key={user.id}
                      onClick={() =>
                        handleReferralSelect(user)
                      }
                    >
                      {user.name}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          {/* GST */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              marginBottom: "25px",
            }}
          >
            <input
              type="checkbox"
              id="no_gst"
              checked={formData.no_gst || false}
              onChange={(e) =>
                setFormData((prevData) => ({
                  ...prevData,
                  no_gst: e.target.checked,
                }))
              }
              style={{
                width: "18px",
                height: "18px",
                accentColor: "#1e3a8a",
              }}
            />

            <label
              htmlFor="no_gst"
              style={{
                fontSize: "14px",
                color: "#374151",
              }}
            >
              If you don't have a GST number, please
              check this box.
            </label>
          </div>

          {/* PASSWORD */}
          <div style={{ marginBottom: "25px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#374151",
              }}
            >
              Password *
            </label>

            <input
              type="password"
              id="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Enter your password"
              required
              style={{
                width: "100%",
                padding: "14px 16px",
                border: "1px solid #d1d5db",
                borderRadius: "12px",
                fontSize: "15px",
                outline: "none",
              }}
            />
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            style={{
              width: "100%",
              padding: "15px",
              border: "none",
              borderRadius: "12px",
              background:
                "linear-gradient(to right, #fbbf24, #f59e0b)",
              color: "#fff",
              fontWeight: "700",
              fontSize: "16px",
              cursor: "pointer",
              boxShadow: "0 10px 25px rgba(251,191,36,0.3)",
            }}
          >
            SIGNUP
          </button>
        </form>

        <div
          style={{
            marginTop: "30px",
            textAlign: "center",
            color: "#6b7280",
            fontSize: "15px",
          }}
        >
          Already have an account?{" "}
          <a
            href="/login"
            style={{
              color: "#1e3a8a",
              fontWeight: "700",
              textDecoration: "none",
            }}
          >
            Sign in instead
          </a>
        </div>
      </div>
    </div>
  </div>
);
};

export default Signup;


